<template>
  <div class="bg-gray20">
    <div class="container BODY-CONTAINER">
      <transition name="fade" mode="out-in">
        <div class="d-flex fd-column ai-center">
          <div class=" p-t-6 h3 text-center">Text Message Opt In Terms & Conditions</div>
          <div class="text-center p-b-3">
            Pro Referral may send you text messages about this service request.
            Message & data rates may apply.
            Texts message frequency varies and may be sent between 8:00 am & 9:00 pm.
            Text STOP to cancel or HELP for help. For questions, contact 1-855-723-2266.
            <router-link :to="{ name: 'about::legal::privacy' }" class="link">
              Privacy & Security Statement
            </router-link>
          </div>
          <div>
            <button
                @click.prevent="decline"
                type="button"
                class="btn-secondary ROUNDED m-r-1">
              Decline
            </button>
            <button
                @click="accept"
                type="button"
                class="btn ROUNDED">
              Accept
            </button>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import workOrder from '@/mixins/work-order';
import authWithToken from '@/mixins/auth-token';
import http from '@homeservices/api-kit/axios';

export default {
  name: 'text-opt-in',
  components: {

  },
  mixins: [
    workOrder,
    authWithToken,
  ],
  computed: {
    ...mapGetters('user', [
      'isPro',
      'isLoggedIn',
    ]),
    token () {
      return this.$route.query.token;
    },
    jobId () {
      return this.$route.query.job_id;
    },
  },
  async mounted () {
    await this.$store.dispatch('user/logoutAndClearUserSession');
    if (!this.isLoggedIn || this.isPro) {
      await this.authenticateWithToken(this.token);
    }
    if (!this.workOrder) {
      await this.fetchWorkOrder({ orderHash: this.jobId, includePublicProfiles: true });
    }
  },
  methods: {
    async decline () {
      this.$router.push({
        path: '/',
      });
    },
    async accept () {
      try {
        await http.put(`/platform/workorder/r/workorder/sms/optin/v2?work_order_hash=${this.jobId}`);
        this.$router.push({
          name: 'consumer::opt-in::success',
        });
      } catch (error) {
        this.$router.push({
          name: 'consumer::opt-in::error',
          query: {
            job_id: this.jobId,
            token: this.token,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools.scss";

.BODY-CONTAINER {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  max-width: 780px;
  @include mobile-only() {
    max-width: 95vw;
  }
}
.ROUNDED {
  border-radius: 5px;
}
</style>
